import {BaseRemoteConfiguration, REMOTE_CONFIG} from "../../infrastructure/models/base-remote-configuration";

export const APP_REMOTE_CONFIG = {
  GDPR_INCLUDES_COUNTRIES: {
    key: 'GDPR_INCLUDES_COUNTRIES',
    default: "-1",
    type: REMOTE_CONFIG.KEY_TYPES.string
  },

  NOTIFICATIONS_NOTICE_SESSION_GAP: {
    key: 'NOTIFICATIONS_NOTICE_SESSION_GAP',
    default: 1,
    type: REMOTE_CONFIG.KEY_TYPES.number
  },

  SECONDS_BEFORE_DISPLAY: {
    key: 'SECONDS_BEFORE_DISPLAY',
    default: 10,
    type: REMOTE_CONFIG.KEY_TYPES.number
  },

  BETTING_PROMOTION: {
    key: 'BETTING_PROMOTION',
    default: "{}",
    type: REMOTE_CONFIG.KEY_TYPES.json
  },

  FM_GAMES_TO_PRESENT_FOR_ALLSCORES: {
    key: 'FM_GAMES_TO_PRESENT_FOR_ALLSCORES',
    default: 4,
    type: REMOTE_CONFIG.KEY_TYPES.number
  },

  FM_GAMES_TO_PRESENT_FOR_MYSCORES: {
    key: 'FM_GAMES_TO_PRESENT_FOR_MYSCORES',
    default: 4,
    type: REMOTE_CONFIG.KEY_TYPES.number
  },

  FM_GAMES_TO_PRESENT_FOR_COMPETITION: {
    key: 'FM_GAMES_TO_PRESENT_FOR_COMPETITION',
    default: 4,
    type: REMOTE_CONFIG.KEY_TYPES.number
  },

  FM_GAMES_TO_PRESENT_FOR_COMPETITOR: {
    key: 'FM_GAMES_TO_PRESENT_FOR_COMPETITOR',
    default: 1,
    type: REMOTE_CONFIG.KEY_TYPES.number
  },

  BOLAO_SHOW_GAME: {
    key: 'BOLAO_SHOW_GAME',
    default: false,
    type: REMOTE_CONFIG.KEY_TYPES.boolean
  },

  BOLAO_SHOW_NAVIGATIONS: {
    key: 'BOLAO_SHOW_NAVIGATIONS',
    default: false,
    type: REMOTE_CONFIG.KEY_TYPES.boolean
  },

  TERMS_REQUEST_VERSION: {
    key: 'TERMS_REQUEST_VERSION',
    default: 2,
    type: REMOTE_CONFIG.KEY_TYPES.number
  },

  MINIMUM_FOLLOWING_TO_DISPLAY: {
    key: 'MINIMUM_FOLLOWING_TO_DISPLAY',
    default: 1000,
    type: REMOTE_CONFIG.KEY_TYPES.number
  },

  ENTITY_DESCRIPTION_AND_FAQ_DISPLAY: {
    key: 'ENTITY_DESCRIPTION_AND_FAQ_DISPLAY',
    default: false,
    type: REMOTE_CONFIG.KEY_TYPES.boolean
  },

  ENTITY_DESCRIPTION_CONFIG: {
    key: 'ENTITY_DESCRIPTION_CONFIG',
    default: "{display:true,sportTypeIds:[1,2,3,6,7],languageIds:[1,31,27,29],entityTypes:[0,1],competitionIds:[183,6196,167],competitorIds:[105,106,131,132,559],userCountryIds:[-1,1,2,3,4,5,18,10,8,11,14,7,139,136,36,20,21,66,28,35,179,109,153,51,131,65,140,80,81,114,6,34,119,123,31,127,83,108,112,29,122,133,134,125,163,118,135,12,166,111,110,319,320,321,322,323,324,325,326,327,328,329,330,331,332,333,334,335,336,337,338,339,340,341,342,343,344,345,346,347,348,349,350,351,352,353,354,355,356,357,358,359,360,361,362,363,364,365,366,367,368,369,370,371,372,373,374,375]}",
    type: REMOTE_CONFIG.KEY_TYPES.json
  },

  PROMOTION_BANNER: {
    key: 'PROMOTION_BANNER',
    default: "{}",
    type: REMOTE_CONFIG.KEY_TYPES.json
  },

  TRANSFERS_COMPETITION_CARDS: {
    key: 'TRANSFERS_COMPETITION_CARDS',
    default: 40,
    type: REMOTE_CONFIG.KEY_TYPES.number
  },

  TRANSFERS_PREVIEW_CARDS_DESKTOP: {
    key: 'TRANSFERS_PREVIEW_CARDS_DESKTOP',
    default: 4,
    type: REMOTE_CONFIG.KEY_TYPES.number
  },

  TRANSFERS_PREVIEW_CARDS_MOBILE: {
    key: 'TRANSFERS_PREVIEW_CARDS_MOBILE',
    default: 3,
    type: REMOTE_CONFIG.KEY_TYPES.number
  },

  FIFTH_BUTTON: {
    key: 'FIFTH_BUTTON',
    default: "{}",
    type: REMOTE_CONFIG.KEY_TYPES.json
  },

  MUNDIAL_BETTING_BUTTON_CONFIG: {
    key: 'MUNDIAL_BETTING_BUTTON_CONFIG',
    default: "{}",
    type: REMOTE_CONFIG.KEY_TYPES.json
  },

  DYNAMIC_COACHMARKS: {
    key: 'DYNAMIC_COACHMARKS',
    default: "{}",
    type: REMOTE_CONFIG.KEY_TYPES.json
  },

  IMPORTANT_INFORMATION_STRIP_DISPLAY: {
    key: 'IMPORTANT_INFORMATION_STRIP_DISPLAY',
    default: false,
    type: REMOTE_CONFIG.KEY_TYPES.boolean
  },

  AUTO_DISPLAY_POPUP_CONFIG: {
    key: 'AUTO_DISPLAY_POPUP_CONFIG',
    default: "{}",
    type: REMOTE_CONFIG.KEY_TYPES.json
  },

  POPUP_CONFIG_TEST: {    //TODO: remove after testing
    key: 'POPUP_CONFIG_TEST',
    default: "{}",
    type: REMOTE_CONFIG.KEY_TYPES.json
  },

  WEB_DYNAMIC_POPUP: {
    key: 'WEB_DYNAMIC_POPUP',
    default: "{}",
    type: REMOTE_CONFIG.KEY_TYPES.json
  },


  WEB_DYNAMIC_POPUP_TEST: {
    key: 'WEB_DYNAMIC_POPUP_TEST',
    default: "[]",
    type: REMOTE_CONFIG.KEY_TYPES.json
  },

  COPPER6_AD_CONFIG: {
    key: 'COPPER6_AD_CONFIG',
    default: "null",
    type: REMOTE_CONFIG.KEY_TYPES.json
  },

  EXTERNAL_AD_CONFIG: {
    key: 'EXTERNAL_AD_CONFIG',
    default: "{}",
    type: REMOTE_CONFIG.KEY_TYPES.json
  },
  GRID_LAYOUT_CONFIG: {
    key: 'GRID_LAYOUT_CONFIG',
    default: "{}",
    type: REMOTE_CONFIG.KEY_TYPES.json
  },
  BET_BOOSTS_CONFIGURATION: {
    key: 'BET_BOOSTS_CONFIGURATION',
    default: "{}",
    type: REMOTE_CONFIG.KEY_TYPES.json
  },
  MINUTE_MEDIA_PLAYER: {
    key: 'MINUTE_MEDIA_PLAYER',
    default: "{\"enabled\": true, \"percentage\": 0.5}",
    type: REMOTE_CONFIG.KEY_TYPES.json
  }
}

export class AppRemoteConfig extends BaseRemoteConfiguration {
  get defaultConfig() {
    return Object.values(APP_REMOTE_CONFIG);
  }
}
